// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** St. Kitts & Nevis */
const KN = /^(?:869(?:48[89]|55[6-8]|66\d|76[02-7])\d{4})$/;

export default KN;
